import { Maybe, ParsedPreset } from '@aibees/shared/definition';
import { QueryOptions, useBaseQuery } from '@aibees/shared/http';
import { jsonParse } from '@aibees/shared/utils';
import { useWorkspace } from '@aibees/shared/workspace';
import { PRESET_API_PREFIX } from './constants';

export function useReadPresetApi<T>(id: Maybe<string>, options?: QueryOptions) {
  const workspace = useWorkspace()?.id;

  return useBaseQuery<any, ParsedPreset<T>, ParsedPreset<T>>(
    [useReadPresetApi.name, id],
    {
      url: `${PRESET_API_PREFIX.replace(':id', String(workspace))}/${id}`,
    },
    {
      ...options,
      select: (data) => {
        data.value = jsonParse(data.value) as T;
        return data;
      },
    }
  );
}
